var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOverviewInfo3 = function SvgOverviewInfo3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 33.3333C28.3333 35.1743 29.8257 36.6667 31.6667 36.6667C33.5076 36.6667 35 35.1743 35 33.3333C35 31.4924 33.5076 30 31.6667 30C29.8257 30 28.3333 31.4924 28.3333 33.3333ZM28.3333 33.3333H25",
    stroke: "var(--konflux-primary-color)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 6.66667C11.6667 8.50762 10.1743 10 8.33333 10C6.49238 10 5 8.50762 5 6.66667C5 4.82572 6.49238 3.33333 8.33333 3.33333C10.1743 3.33333 11.6667 4.82572 11.6667 6.66667ZM11.6667 6.66667L15 6.66667",
    stroke: "var(--konflux-primary-color)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 6.66667L20 6.66667",
    stroke: "var(--konflux-primary-color)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 33.3333H16.6667",
    stroke: "var(--konflux-primary-color)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 33.3333C18.3333 33.3333 21.6667 6.66667 35 6.66667",
    stroke: "var(--konflux-primary-color)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgOverviewInfo3;